import queryTypes from '../../constants/usage';
import { dateColumns } from '../../constants/event';

const composeInitialState = {
  groupColumn: dateColumns.DAY,
  splitColumn: undefined,
  queryType: queryTypes.USERS,
};

const compose = (state = composeInitialState, action) => {
  switch (action.type) {
    case 'USAGE_COMPOSE_SET_GROUP_COLUMN':
      return {
        ...state,
        groupColumn: action.groupColumn,
      };
    case 'USAGE_COMPOSE_SET_SPLIT_COLUMN':
      return {
        ...state,
        splitColumn: action.splitColumn,
      };
    case 'CHANGE_USAGE_QUERY_TYPE':
      return {
        ...composeInitialState,
        queryType: action.queryType,
      };

    default:
      return state;
  }
};

export default compose;

export const getGroupColumn = (state) => state.groupColumn;

export const getSplitColumn = (state) => state.splitColumn;

export const getQueryType = (state) => state.queryType;
